// src/utils/HelmetTemplate.js
import React from 'react';
import { Helmet } from 'react-helmet';

const HelmetTemplate = ({ title, description, canonicalUrl }) => (
  <Helmet>
    <title>{title}</title>
    {description && <meta name="description" content={description} />}
    {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
  </Helmet>
);

export default HelmetTemplate;
